// SPDX-FileCopyrightText: Copyright 2025 OP Financial Group (https://op.fi). All Rights Reserved.
//
// SPDX-License-Identifier: LicenseRef-OpAllRightsReserved

import React from 'react';
import RedirectButton from '../../components/RedirectButton';
import { pageRoutes } from '../../Constants';
import message from '../../messages';

const ManualSigningBackButton: React.FC = () => {
    return (
        <RedirectButton
            className="navigation-button"
            id="backButton"
            to={pageRoutes.infoPreview}
            onClick={() => {
                window.scrollTo(0, 0);

                return true;
            }}
        >
            {message('back')}
        </RedirectButton>
    );
};

export default ManualSigningBackButton;
